import log from "loglevel";
import React, { useRef, useState } from "react";
// import { useHistory } from 'react-router-dom';
import MarkdownIt from 'markdown-it';
import "react-markdown-editor-lite/lib/index.css";
import Card from "react-bootstrap/Card";
import * as constants from "Constants";
import httpService from 'services/httpService.js';
import { Container, Col, Row, Button, Form } from "react-bootstrap";
import displayGlobalMessage from "Utils/DisplayGlobalMessage";
import { AiOutlineEdit, AiTwotoneDelete } from "react-icons/ai";
import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css'; // Import the CSS
import { useLocation, useNavigate, useParams } from "react-router-dom";
import CustomCKEditor from "Components/CustomCKEditor";



export const PageInfoInstructor = ({ courseID, pages, setPages }) => {
  // log.log(pageid)
  const { pageid } = useParams();
  log.log(pageid)
  log.log(pages)
  const md = new MarkdownIt({ underline: true, });
  // const history = useHistory();
  const [showForm, setShowForm] = useState(false);

  const index = pages?.findIndex(obj => obj.id == pageid);
  log.log(index)

  const showConfirmationDialog = () => {
    confirmAlert({
      title: 'Confirm Delete',
      message: "Are you sure you want to delete page " + pages[index].title + "?",
      buttons: [
        {
          label: 'Yes',
          onClick: pageDelete
        },
        {
          label: 'No',
          onClick: () => { /* Do nothing */ }
        }
      ]
    });
  };

  const pageDelete = async () => {
    let url = constants.base_url + "/document/api/page/" + pageid + "/";
    try {
      await httpService.delete(url);
      pages.splice(index, 1);
      setPages(pages.filter(page => page.id !== pageid));
      displayGlobalMessage("Page Deleted Successfully", "success");
      // history.push("/courseware/course/" + courseID +"/content/multimedia")
    } catch (err) {
      displayGlobalMessage(`${err}`, "error");
    }
  };

  const EditPage = () => {
    const [updatedTitle, setUpdatedTitle] = useState(pages[index].title)
    const [updatedDescription, setUpdatedDescription] = useState(pages[index].description)
    const mdParser = new MarkdownIt({ underline: true, });
    const handleEditorChange = (html, text) => {
      var values = Object.values(html);
      var keys = Object.keys(html);
      setUpdatedDescription(values[0]);
    };
    const onImageUpload = (file) => {
      return new Promise((resolve) => {
        const reader = new FileReader();
        reader.onload = (data) => {
          resolve(data.target.result);
        };
        reader.readAsDataURL(file);
      });
    };
    const handleSubmit = async () => {
      let url = constants.base_url + "/document/api/page/" + pageid + "/";
      try {
        await httpService.patch(url, { "title": updatedTitle, "description": updatedDescription });
        log.log(pages);
        pages[index].title = updatedTitle;
        pages[index].description = updatedDescription;
        log.log(pages);
        setPages((prev) => {
          log.log(prev);
          log.log(pages);
          return pages;
        });
        displayGlobalMessage("Updated Course info", "success");
        setShowForm(false);
      } catch (err) {
        displayGlobalMessage(`${err}`, "error");
      }
    };
    return (
      <Container fluid="xl">
        <Card border="info">
          <Card.Header as="h5" className="text-center">
            Edit Description
          </Card.Header>
          <Card.Body>
            <Form>
              <Form.Group className="mb-3" controlId="formBasicEmail">
                <Form.Label>Title</Form.Label>
                <Form.Control
                  // style={{ width: "1100px" }}
                  type="email"
                  placeholder="Page Title"
                  value={updatedTitle}
                  onChange={(e) => {
                    setUpdatedTitle(e.target.value);
                  }}
                />
                <Form.Text className="text-muted">
                  Give a Short Title to your Document.
                </Form.Text>
              </Form.Group>
              <Form.Group className="mb-3" controlId="formBasicPassword">

                {/* <MdEditor
                    style={{ height: "500px" }}
                    renderHTML={(text) => mdParser.render(text)}
                    onChange={handleEditorChange}
                    onImageUpload={onImageUpload}
                    value = {updatedDescription}
                    parser={mdParser}
                  /> */}

                <CustomCKEditor
                  name="Page Description"
                  placeholder="Desciption"
                  value={updatedDescription}
                  onChange={(data) => {
                    setUpdatedDescription(data.html)
                  }}
                />

              </Form.Group>
            </Form>
            <Row>
              <Col>
                <Button variant="primary" onClick={handleSubmit}>
                  Submit
                </Button>
              </Col>
              <Col>

                <Button variant="danger" onClick={() => setShowForm(false)}>
                  Cancel
                </Button>
              </Col>
            </Row>
          </Card.Body>
        </Card>
      </Container>
    );

  }

  return (index === -1) ? <div>Page is not available. Might be deleted.</div> : (showForm ? <EditPage /> : (
    <div className="bg-white">
      <Row style={styles.outerbox}>
        <Col xs={12} className="d-flex justify-content-between align-items-center">
          <div className="d-flex gap-2 align-items-center">
            <h4 className="mb-0" style={styles.headerStyle}>{pages[index].title}</h4>
            <Button className="mx-2" size="sm" variant="outline-primary" onClick={() => setShowForm(true)}>
              <AiOutlineEdit className="mr-1" />
              Edit
            </Button>
          </div>
          <Button size="sm" variant="danger" onClick={() => showConfirmationDialog()}>
            <AiTwotoneDelete />
            Delete
          </Button>
        </Col>
        <Col xs={12}>
          <hr
            style={{
              margin: 0,
              height: "2px",
              border: "none",
              backgroundColor: "grey",
            }}
          />
        </Col>
        <Col xs={12}>
          {/* <div dangerouslySetInnerHTML={{ __html: md.render(pages[index].description) }} /> */}
          <div dangerouslySetInnerHTML={{ __html: pages[index].description }} />
        </Col>
      </Row>
    </div>
  ));
}

export const AddPage = ({ courseID, pages, setPages }) => {
  const [title, setTitle] = useState("")
  const [description, setDescription] = useState("")
  const addPageFormRef = useRef(null);
  const location = useLocation();
  const navigate = useNavigate();

  // const mdParser = new MarkdownIt({ underline: true, });
  // const history = useHistory();
  // const handleEditorChange = (html, text) => {
  //   var values = Object.values(html);
  //   var keys = Object.keys(html);
  //   setDescription(values[0]);
  // };

  const _onImageUpload = (file) => {
    return new Promise((resolve) => {
      const reader = new FileReader();
      reader.onload = (data) => {
        resolve(data.target.result);
      };
      reader.readAsDataURL(file);
    });
  };
  const handleSubmit = async () => {
    let url = constants.base_url + "/courseware/api/course/" + courseID + "/add_page/";
    try {
      const res = await httpService.post(url, { "title": title, "description": description });
      setPages([...pages, res.data]);
      displayGlobalMessage("Successfully added Page", "success");
      navigate("/courseware/course/" + courseID + "/pages/" + res.data.id);
    } catch (err) {
      displayGlobalMessage(`${err}`, "error");
    }
  };
  return (
    <Container fluid="xl">
      <Card border="info" style={{ overflow: "visible", zIndex: 1 }}>
        <Card.Header as="h5" className="text-center">
          Add Page
        </Card.Header>
        <Card.Body>
          <Form ref={addPageFormRef} key={location.pathname}>
            <Form.Group className="mb-3" controlId="formBasicEmail">
              <Form.Label>Title</Form.Label>
              <Form.Control
                // style={{ width: "1100px" }}
                type="email"
                placeholder="Page Title"
                value={title}
                onChange={(e) => {
                  setTitle(e.target.value);
                }}
              />
              <Form.Text className="text-muted">
                Give a Short Title to your Document.
              </Form.Text>
            </Form.Group>

            <Form.Group className="mb-3" controlId="formBasicPassword">
              <Form.Label>Description</Form.Label>
              {/* <MdEditor
                  style={{ height: "500px" }}
                  renderHTML={(text) => mdParser.render(text)}
                  onChange={handleEditorChange}
                  onImageUpload={onImageUpload}
                  value={description}
                  // value = {value}
                /> */}
              <CustomCKEditor
                name="Page Description"
                placeholder="Desciption"
                value={description}
                onChange={(data) => {
                  setDescription(data.html)
                }}
              />
            </Form.Group>
          </Form>

          <Button variant="primary" onClick={handleSubmit}>
            Submit
          </Button>
        </Card.Body>
      </Card>
    </Container>
  );
}
const styles = {
  outerbox: {
    border: "1px solid #ccc",
    marginLeft: 15,
    padding: 20,
  },
  headerStyle: {
    color: "grey",
    display: "inline"
  },
  buttonbox: {
    padding: "0 20",
  },
};